import { useToggle } from 'ahooks'
import { Button, Modal, Table } from 'antd'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { TextContent } from '@/components'

const HelpContent = () => {
  const columns = [
    {
      title: '结果',
      dataIndex: 'result',
      key: 'result',
      width: '50%',
      render: (t: string) => <TextContent isMarkdown content={t} mentions={[]} />,
    },
    {
      title: '格式设置',
      dataIndex: 'format',
      key: 'format',
      width: '50%',
    },
  ]

  const dataSource = [
    { result: '**加粗**', format: '**文本**' },
    { result: '*强调*', format: '*文本*' },
    { result: '~~删除~~', format: '~~文本~~' },
    { result: '[链接](https://agoralab.co)', format: '[标题](https://agoralab.co)' },
    { result: '`内联代码`', format: `代码` },
    { result: '- 列表', format: '- 条目' },
    { result: '1. 编号清单', format: '1. 第一个条目' },
    { result: '> 引用', format: '> 引用' },
    { result: '# H1', format: '# 标题' },
    { result: '## H2', format: '## 标题' },
  ]
  return <Table dataSource={dataSource} columns={columns} rowKey='result' size='small' pagination={false} />
}

export const PostEditorHelp = () => {
  const [t] = useTranslation()
  const [visible, { toggle }] = useToggle()

  return (
    <>
      <Button type='link' onClick={() => toggle()}>
        Markdown {t('post.markdownHelp')}
      </Button>
      <Modal
        title={t('post.markdownHelp')}
        visible={visible}
        footer={false}
        onCancel={() => toggle()}
        centered
        destroyOnClose
      >
        <HelpContent />
      </Modal>
    </>
  )
}
